/**
 * Copy for the audio card's SSR template — the server build has no i18n runtime. Each value must stay
 * byte-identical to its `translations/en-US.json` key, or the text changes on hydration.
 */
export const AUDIO_CARD_LABELS = {
    /** `audioCardUnlisted` */
    unlisted: 'Unlisted',
    /** `audioCardMoreActions` */
    moreActions: 'More audio actions',
    /** `audioActionsSheetTitle` */
    actionsSheetTitle: 'Select an Action',
    /** `commonCancel` */
    cancel: 'Cancel',
    /** `audioCardDownload` */
    download: 'Download',
    /** `likeButtonLike` */
    like: 'Like',
    /** Hardcoded in audio-web `audio-tags/strings.ts`, so it has no en-US key to lock against. */
    noCategory: 'No Category',
}
